import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listGeosetsQueryOptions } from '@/services/db/geoset/queries';
import type { GeosetNode } from '../../types';
import { getIconForNode } from '../data-source-icon';

const ACTIVITY_LABELS = {
  entered: 'Entered',
  dwelled: 'Dwelled in',
  exited: 'Exited',
} satisfies Record<GeosetNode['activity'], string>;

/** The geofence sets by name, or `geofence set <id>` for one that no longer exists. */
function useGeosetNames(geosetIds: readonly number[], workspaceId: number): string {
  const queryClient = useQueryClient();
  const { data } = useQuery({ ...listGeosetsQueryOptions(workspaceId, queryClient), enabled: workspaceId > 0 });
  if (geosetIds.length === 0) {
    return 'a geofence set';
  }
  return geosetIds
    .map((id) => data?.geosets.find((geoset) => geoset.id === String(id))?.name ?? `geofence set ${id}`)
    .join(', ');
}

type GeosetConditionProps = { node: GeosetNode; workspaceId: number };

/** A wait until's geofence transition: `Entered Stores`. */
export function GeosetCondition({ node, workspaceId }: GeosetConditionProps) {
  const names = useGeosetNames(node.geosetIds, workspaceId);
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      {ACTIVITY_LABELS[node.activity]} <ConditionViewerTerm>{names}</ConditionViewerTerm>
    </ConditionViewerItem>
  );
}
